export type ManagedJobStatus = {
  state: 'queued' | 'running' | 'waiting' | 'blocked' | 'completed';
  reason: string | null;
};
export type AnalysisJobStatus = {
  documentId: string;
  status: 'queued' | 'processing' | 'completed' | 'failed';
  managedStatus?: ManagedJobStatus | null;
  transcript?: unknown;
  privateOutputRemovedAt?:string|null;
};
export function analysisJobLabel(job: AnalysisJobStatus): string {
  if(job.privateOutputRemovedAt)return 'Analyseinhalte entfernt';
  if (job.status === 'completed') return 'Neue Informationen zum Prüfen';
  if (job.managedStatus) {
    if (job.managedStatus.reason === 'cancelled') return 'Auftrag gestoppt';
    switch (job.managedStatus.state) {
      case 'queued': return 'In der Warteschlange';
      case 'running': return 'Wird analysiert…';
      case 'waiting': return 'Verarbeitung pausiert';
      default: return 'Weitere Verarbeitung gestoppt';
    }
  }
  return job.status === 'queued' ? 'In der Warteschlange' : job.status === 'processing'
    ? 'Wird analysiert…' : job.transcript ? 'Transkript erhalten; weitere Auswertung offen' : 'Nicht abgeschlossen';
}
export function analysisJobMessage(job: AnalysisJobStatus): string | null {
  if(job.privateOutputRemovedAt)return 'Original und bereits übernommene Angaben bleiben gespeichert. Es wird keine alte Analyse erneut ausgeführt; Kosten und ungeklärte Abrechnung bleiben bestehen.';
  if (!job.managedStatus || job.status === 'completed') return null;
  switch (job.managedStatus.reason) {
    case 'accounting_unresolved': return 'Die Abrechnung übertragener Teile ist noch ungeklärt. Bereits gesendete Teile werden nicht erneut übertragen. Gespeicherte Transkripte bleiben verfügbar.';
    case 'private_output_unavailable': return 'Ein übertragenes Ergebnis ist nicht mehr verfügbar. Es wird keine automatische neue kostenpflichtige Analyse gestartet. Bereits entstandene Kosten bleiben bestehen.';
    case 'admission_changed': return 'Dienst oder Freigabe haben sich geändert. Für diesen Auftrag wird keine neue Übertragung gestartet.';
    case 'source_withdrawn': return 'Die Datei oder Haushaltsberechtigung hat sich geändert. Die Verarbeitung ist beendet.';
    case 'worker_unavailable': return job.managedStatus.state === 'waiting'
      ? 'Die Verarbeitung ist vorübergehend unterbrochen. Der bestehende Auftrag bleibt gespeichert; bereits gesendete Teile werden nicht erneut übertragen.'
      : 'Die automatische Fortsetzung ist beendet. Es wird keine neue kostenpflichtige Analyse gestartet.';
    case 'cancelled': return 'Für diesen Auftrag wird keine weitere Verarbeitung gestartet. Ein Stopp erstattet keine bereits entstandenen Kosten.';
    case null: return null;
    default: return 'Dieser gespeicherte Auftrag kann derzeit nicht fortgesetzt werden. Eure Unterlagen und vorhandenen Ergebnisse bleiben verfügbar.';
  }
}
export function analysisCanStop(job: AnalysisJobStatus): boolean {
  return ['queued', 'processing'].includes(job.status);
}
export function analysisCanStart(documentId: string, jobs: AnalysisJobStatus[]): boolean {
  return !jobs.some(job => job.documentId === documentId && (job.managedStatus != null||job.privateOutputRemovedAt!=null));
}
export function analysisPollDelay(jobs: AnalysisJobStatus[]): number {
  return jobs.some(job => job.managedStatus
    ? ['queued', 'running'].includes(job.managedStatus.state) && analysisCanStop(job)
    : analysisCanStop(job)) ? 5000 : 15000;
}
